import React, { Component } from 'react';
import ms from 'ms';
import { connect } from 'react-redux';
import { Button } from 'ui';
import Table from 'components/shared/table';
import { removeAttendance } from 'actions/inPersonTraining/attendances';

class AttendanceRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      justAdded: Date.now() - this.props.attendance.dateAdded <= ms('1s'),
    };
  }

  componentDidMount() {
    if (this.state.justAdded) {
      setTimeout(() => this.setState({ justAdded: false }), 500);
    }
  }

  render() {
    const { onRemove, attendance } = this.props;
    return (
      <Table.Row selected={this.state.justAdded}>
        <Table.BodyCell split className="fz-bigger">
          {attendance.user.name}
          <Button square icon="delete" onClick={onRemove} />
        </Table.BodyCell>
      </Table.Row>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onRemove: () => dispatch(removeAttendance(ownProps.attendance)),
});

export default connect(null, mapDispatchToProps)(AttendanceRow);
